import { Component, OnInit } from '@angular/core';

//This component exists as a place the server render can navigate to before navigatign to the 
//intended page to ensure it is always a clean navigation
@Component({
  selector: 'app-render-placeholder',
  templateUrl: './render-placeholder.component.html',
  styleUrls: ['./render-placeholder.component.scss']
})
export class RenderPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
 